import { useState } from 'react';

type ToastType = 'default' | 'destructive' | 'success';

interface Toast {
    id: string;
    title: string;
    description: string;
    type: ToastType;
}

export function useToast() {
    const [toasts, setToasts] = useState<Toast[]>([]);

    const toast = ({
        title,
        description,
        variant = 'default',
    }: {
        title: string;
        description: string;
        variant?: ToastType;
    }) => {
        const id = Math.random().toString(36).substring(2, 9);
        const newToast: Toast = { id, title, description, type: variant };

        setToasts((prev) => [...prev, newToast]);

        // Auto-remove toast after 5 seconds
        setTimeout(() => {
            setToasts((prev) => prev.filter((t) => t.id !== id));
        }, 5000);
    };

    const removeToast = (id: string) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    };

    return { toast, toasts, removeToast };
}
